<script lang="ts">
    import { _ } from "svelte-i18n"
    import Index from "../SEO/Index.svelte"
</script>

<Index noIndex="{true}" title="404 Not found" metaDescription="Diese Seite wurde nicht gefunden" />
<section class="section_padding">
    <div class="container-fluid">
        <h1>404 Not found</h1>
        <p>Site not found - {$_("not-found.site-not-found")}</p>
    </div>
</section>
